import {
    STORE_FORM_REQUEST,
    STORE_FORM_SUCCESS,
    STORE_FORM_FAILURE,
    UPLOAD_FILE_REQUEST,
    UPLOAD_FILE_DELETE,
    UPLOAD_FILE_UPLOADING,
    UPLOAD_FILE_SUCCESS,
    UPLOAD_FILE_FAILURE,
    UPDATE_ADDRESS,
    LOAD_SERVICE_STATE,
    GET_QUOTE_REQUEST,
    GET_QUOTE_SUCCESS,
    GET_QUOTE_FAILURE,
    CHECK_MAPSHARE_REQUEST,
    CHECK_MAPSHARE_SUCCESS,
    CHECK_MAPSHARE_FAILURE
} from './types';

import axios from 'axios';
import * as helpers from "../helpers/actionsHelpers";

export const loadServiceState = (data) => {
    return {
        type: LOAD_SERVICE_STATE,
        payload: data
    }
}

export const updateAddress = (id, value, isSelected, isManual, required) => {
    return {
        type: UPDATE_ADDRESS,
        payload: {
            id,
            value,
            isSelected,
            isManual,
            required
        }
    }
}

export const deleteFile = transactionID => {
    return {
        type: UPLOAD_FILE_DELETE,
        payload: transactionID
    };
};

export const uploadFile = (id, data, category, subCategory, url) => async(dispatch, getState) => {

    const file = getState().service.attachments.find(file => (
        file.originalFileName === data.name &&
        file.fileSize === data.size &&
        file.id === id))

    if ((typeof file === 'undefined' || (file && file.error !== '')) && data && category && subCategory) {

        dispatch({
            type: UPLOAD_FILE_REQUEST,
            payload: {
                id: id,
                originalFileName: data.name,
                isUploading: false,
                category: category,
                subCategory: subCategory,
                fileSize: data.size,
                percentage: 0,
                error: ''
            }
        });

        var formData = new FormData();
        formData.append("attachment", data, data.name);
        formData.append("attachmentFileName", data.name);

        var CancelToken = axios.CancelToken;
        var cancel;

        const options = {
            method: 'POST',
            data: formData,
            url: url,
            onUploadProgress: progressEvent => {
                let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
                let fileInUpload = getState().service.attachments.find(file => (
                    file.originalFileName === data.name &&
                    file.fileSize === data.size &&
                    file.id === id))
                if (percentCompleted !== 0 && !fileInUpload) {
                    cancel();
                } else {
                    dispatch({
                        type: UPLOAD_FILE_UPLOADING,
                        payload: {
                            id: id,
                            originalFileName: data.name,
                            fileSize: data.size,
                            isUploading: true,
                            percentage: percentCompleted
                        }
                    });
                }
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancel = c;
            })
        }

        const instance = axios.create();

        instance.interceptors.response.use(
            function(response) {
                return response;
            },
            function(error) {
                if (!error.response) {
                    dispatch({
                        type: UPLOAD_FILE_FAILURE,
                        payload: {
                            id: id,
                            originalFileName: data.name,
                            isUploading: false,
                            error: "Please check your internet connection",
                            fileSize: data.size,
                            percentage: 0
                        }
                    });
                }
                return Promise.reject(error);
            }
        );

        instance(options)
            .then(function(response) {
                dispatch({
                    type: UPLOAD_FILE_SUCCESS,
                    payload: {
                        id: id,
                        originalFileName: data.name,
                        attachmentURI: response.data.uri,
                        transactionID: response.data.transactionId,
                        isUploading: false,
                        fileSize: data.size,
                        percentage: 100
                    }
                });
            })
            .catch(function(error) {
                dispatch({
                    type: UPLOAD_FILE_FAILURE,
                    payload: {
                        id: id,
                        originalFileName: data.name,
                        isUploading: false,
                        error: error.response.data.message || error.message,
                        fileSize: data.size,
                        percentage: 0
                    }
                });
            });
    }

}

export const storeFormData = (data, url) => async(dispatch, getState) => {

    if (data) {

        var formData = new FormData();
        const postData = helpers.prepareDataAPI({...data }, getState());

        dispatch({
            type: STORE_FORM_REQUEST
        })

        formData.append("data", JSON.stringify(postData));

        const options = {
            method: 'POST',
            data: formData,
            headers: { 'Content-Type': 'application/json' },
            url: url,
        }

        const instance = axios.create();
        instance.interceptors.response.use(
            function(response) {
                return response;
            },
            function(error) {
                if (!error.response) {
                    dispatch({
                        type: STORE_FORM_FAILURE,
                        payload: {
                            code: "No Internet Connection",
                            message: [{ "message": "Please check your internet connection" }]
                        }
                    });
                }
                return Promise.reject(error);
            }
        );

        instance(options)
            .then(function(response) {
                if (response.data.code) {
                    //failed
                    dispatch({
                        type: STORE_FORM_FAILURE,
                        payload: {
                            code: response ? response.data.code : '',
                            message: response ? response.data.message : ''
                        }
                    });
                } else {
                    dispatch({
                        type: STORE_FORM_SUCCESS,
                        payload: response.data
                    });

                    // remove window onbeforeunload
                    window.onbeforeunload = function() {}

                    // scroll to to top of page
                    document.getElementById("hero-app").scrollIntoView({ behavior: 'smooth' });

                }
            })
            .catch(function(error) {
                dispatch({
                    type: STORE_FORM_FAILURE,
                    payload: {
                        code: error.response ? error.response.data.code : '',
                        message: error.response ? error.response.data.message : ''
                    }
                });
            });
    }
}

export const getQuoteCall = (data, url) => async(dispatch, getState) => {

    if (data) {

        dispatch({
            type: GET_QUOTE_REQUEST
        });

        var formData = new FormData();
        const postData = helpers.getFeeQuote({...data }, getState());

        formData.append("data", JSON.stringify(postData));

        const options = {
            method: 'POST',
            data: formData,
            headers: { 'Content-Type': 'application/json' },
            url: url,
        }

        const instance = axios.create();
        instance.interceptors.response.use(
            function(response) {
                return response;
            },
            function(error) {
                if (!error.response) {
                    dispatch({
                        type: GET_QUOTE_FAILURE,
                        payload: {
                            code: "No Internet Connection",
                            message: [{ "message": "Please check your internet connection" }]
                        }
                    });
                }
                return Promise.reject(error);
            }
        );

        instance(options)
            .then(function(response) {
                if (response.data.code) {
                    //failed
                    dispatch({
                        type: GET_QUOTE_FAILURE,
                        payload: {
                            code: response.data.code || '',
                            message: response.data.message || ''
                        }
                    });
                } else {
                    response.data = Object.assign({}, {...response.data, feePayable: response.data.feePayable.toFixed(2) })
                    dispatch({
                        type: GET_QUOTE_SUCCESS,
                        payload: response.data
                    });
                }
            })
            .catch(function(error) {
                dispatch({
                    type: GET_QUOTE_FAILURE,
                    payload: {
                        code: error.response.data.code || '',
                        message: error.response.data.message || ''
                    }
                });
            });
    }
}

export const checkMapshareData = (inputID, isManual) => async(dispatch) => {

    dispatch({
        type: CHECK_MAPSHARE_REQUEST
    });

    const instance = axios.create();
    const options = {
        method: 'GET',
        url: 'https://corp-geo.mapshare.vic.gov.au/arcgis/rest/services/Geocoder/VMAddressEZIAdd/GeocodeServer/suggest?category=&location=&distance=&f=pjson&text=1'
    }

    instance(options)
        .then(function(response) {

            if (response.data.suggestions) {
                dispatch({
                    type: CHECK_MAPSHARE_SUCCESS,
                    payload: true
                });
                // If mapshare data is not available show manual address only fields
                updateAddress(
                    inputID,
                    '',
                    false,
                    isManual === true ? false : true,
                    false
                )
            } else {
                dispatch({
                    type: CHECK_MAPSHARE_FAILURE,
                    payload: false
                });
                // If mapshare data is not available show manual address only fields
                updateAddress(
                    inputID,
                    '',
                    true,
                    isManual === true,
                    false
                )
            }
        })
        .catch(function(error) {
            console.log(error)
            dispatch({
                type: CHECK_MAPSHARE_FAILURE,
                payload: false
            });
            // If mapshare data is not available show manual address only fields
            updateAddress(
                inputID,
                '',
                true,
                isManual === true,
                false
            )
        });
}